import React from 'react';
import { clearUserData } from 'helper/clearUserData';

class Logout extends React.Component {
  async componentDidMount() {
    const clearDB = window.location.href.includes('logout/clear');
    await clearUserData(clearDB);

    window.location.href = '/#/login';
    window.location.reload(true);
  }

  render() {
    return <div style={{ textAlign: 'center', color: 'var(--color-black3)' }}>Logging out...</div>;
  }
}

export default Logout;
